import React from "react";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { wall } from "../upfrontSessionsHelpers";

// A run of classes the pack can't reach, folded to one line on a phone: weeks of
// greyed-out cards otherwise stand between the client and the dates they can pick.
function OutsideValidityRun({ sessions, expanded, onToggle, children }) {
  const first = wall(sessions[0].startDate);
  const last = wall(sessions[sessions.length - 1].startDate);
  const range = first.hasSame(last, "month")
    ? `${first.toFormat("ccc d")} – ${last.toFormat("ccc d LLL")}`
    : `${first.toFormat("ccc d LLL")} – ${last.toFormat("ccc d LLL")}`;

  return (
    <>
      <ButtonBase
        onClick={onToggle}
        aria-expanded={expanded}
        sx={{
          gridColumn: "1 / -1",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 0.75,
          px: 1.5,
          py: 1,
          borderRadius: 2,
          border: "1px dashed",
          borderColor: "divider",
          color: "text.secondary",
          textAlign: "left"
        }}
      >
        {expanded ? <ExpandLessIcon sx={{ fontSize: "1.25rem" }} /> : <ExpandMoreIcon sx={{ fontSize: "1.25rem" }} />}
        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 0 }}>
          {sessions.length} classes outside your pack's dates
          <Typography component="span" variant="caption" sx={{ ml: 0.75 }}>
            · {range}
          </Typography>
        </Typography>
      </ButtonBase>
      {expanded && children}
    </>
  );
}

export default OutsideValidityRun;
